import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    selectedLesson: null,
    userResponses: {}, // { lessonId: { questionId: selectedOptionId } }
    lessonCompleted: false,
    completedLessons: [], // ✅ Ensure it's always an array
    readyToNavigate: false,
    score: 0,
    currentQuestionIndex: 0,
    userAnswers: [],
    quizState: {
        showQuiz: false,
        selectedOption: '',
        correctAnswer: null,
        showNextButton: false,
        showTryAgain: false,
        quizCompleted: false,
        showLessonCompletion: false,
        isFinalLesson: false,
        noOfReattempt: 0,
        showAnswer: false,
    },
    // Added by Rakshwinder
    reattemptsForEveryLesson: 0
};

const lessonSlice = createSlice({
    name: 'lesson',
    initialState,
    reducers: {
        setReadyToNavigate: (state, action) => {
            state.readyToNavigate = action.payload;
        },

        setSelectedLesson: (state, action) => {
            state.selectedLesson = action.payload;
            state.userResponses = {}; // Reset responses when switching lessons
            state.lessonCompleted = false;
        },
        selectAnswer: (state, action) => {
            const { lessonId, questionId, selectedOptionId } = action.payload;

            // ✅ Ensure lesson entry exists before adding answers
            if (!state.userResponses[lessonId]) {
                state.userResponses[lessonId] = {};
            }

            state.userResponses[lessonId][questionId] = selectedOptionId;
        },
        markLessonCompleted: (state, action) => {
            const lessonId = action.payload;

            // ✅ Ensure `completedLessons` is an array
            if (!Array.isArray(state.completedLessons)) {
                state.completedLessons = [];
            }

            // ✅ Prevent duplicate entries
            if (!state.completedLessons.includes(lessonId)) {
                state.completedLessons.push(lessonId);
            }

            state.lessonCompleted = true;
        },
        setCompletedLessons: (state, action) => {
            const newCompletedLessons = action.payload;
            if (Array.isArray(newCompletedLessons)) {
                state.completedLessons = newCompletedLessons;
            }
        },
        resetResponses: (state) => {
            state.userResponses = {};
            state.lessonCompleted = false;
        },
        resetLessonState: (state) => {
            Object.assign(state, {
                ...initialState,
                quizState: { ...initialState.quizState }
            });
        },

        // setQuizState: (state, action) => {
        //     state.quizState = { ...state.quizState, ...action.payload };
        // },
        setQuizState: (state, action) => {
            return { ...state, quizState: { ...state.quizState, ...action.payload } };
        },
        //Added by Rakshwinder
        setReattemptsForLesson: (state, action) => {
            console.log("action",action.payload);
            state.reattemptsForEveryLesson = action.payload;
            console.log("state.reattemptsForEveryLesson",state.reattemptsForEveryLesson);
        },
        resetQuizState: (state) => {
            state.quizState = {
                showQuiz: false,
                selectedOption: '',
                correctAnswer: null,
                showNextButton: false,
                showTryAgain: false,
                quizCompleted: false,
                showLessonCompletion: false,
                showLessonResult: false,
                showFailureScreen: false,
                showAnswer: false,
            };
            state.userAnswers = [];
            state.score = 0;
            state.currentQuestionIndex = 0;
        },

        setUserAnswers: (state, action) => {
            state.userAnswers = action.payload;
        },
        setScore: (state, action) => {
            state.score = action.payload;
        },
        setCurrentQuestionIndex: (state, action) => {
            state.currentQuestionIndex = action.payload;
        },
        resetAllData: (state) => {
            Object.assign(state, initialState);
        },
        clearQuizData: (state) => {
            state.quizState = { ...initialState.quizState };
            state.userAnswers = [];
            state.score = 0;
            state.currentQuestionIndex = 0;
        }
    },
});

export const { setSelectedLesson,
    selectAnswer,
    setReattemptsForLesson,
    markLessonCompleted,
    resetResponses,
    resetLessonState,
    setCompletedLessons,
    setQuizState,
    resetQuizState,
    setUserAnswers,
    setScore, resetAllData, clearQuizData,
    setCurrentQuestionIndex, setReadyToNavigate } = lessonSlice.actions;
export default lessonSlice.reducer;
